import { render, staticRenderFns } from "./AboutTabs.vue?vue&type=template&id=82aa8174&"
import script from "./AboutTabs.vue?vue&type=script&lang=js&"
export * from "./AboutTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports